<template>
  <div class="w-full flex justify-start items-center bg-white h-24 md:h-12 my-1 pl-1" :class="{'bg-ntf-viewed': value.viewedAt !== null}">
    <div class="w-full flex flex-col md:flex-row">
      <div class="w-1/6 flex">
        <span> #{{ value.caseId }} </span>
      </div>

      <div class="w-1/6 flex">
        <span>
          {{ $t(`pages.notifications.titleList.${value.eventType}`) }}
        </span>
      </div>

      <div class="w-1/6 flex">
        <feather-icon icon="SendIcon" class="cursor-pointer mx-1"
                      svg-classes="h-7 w-7 cursor-pointer p-1 rounded bg-gray-200 text-dark hover:bg-danger hover:text-white"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotificationItem",
  props: {
    value: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      user: null,
    }
  },

  watch: {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
  .bg-ntf-viewed {
    background-color: $primary-100;
  }
</style>
